import { ClosableDialog } from 'components/controls/dialogs'
import { Button } from 'components/facets'
import { useTranslation } from 'react-i18next'

interface CardtraderFetchingDialogProps {
  open: boolean
  onClose: () => void
}

export const CardtraderFetchingDialog = ({
  open,
  onClose,
}: CardtraderFetchingDialogProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ClosableDialog maxWidth="sm" open={open} onClose={onClose}>
      <h5 style={{ marginTop: 0 }}>
        {t('connectCardtrader.salesChannelSync.fetchingDialog.title')}
      </h5>
      <p>{t('connectCardtrader.salesChannelSync.fetchingDialog.body')}</p>
      <div className="d-flex justify-content-end" style={{ marginTop: 16 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          data-testid="cardtrader-fetching-dialog-ok"
        >
          {t('connectCardtrader.salesChannelSync.fetchingDialog.ok')}
        </Button>
      </div>
    </ClosableDialog>
  )
}
